const routes = [
  {
    path: '/bulk-keyword-tool',
    name: 'bulk-keyword-tool',
    component: () => import('@/modules/bulk-keyword-tool/pages/Entry.vue'),
    meta: {
      title: 'eRank — Bulk Keyword Tool',
      metaTags: [
        {
          name: 'description',
          content: 'Lookup the estimated search volumes and trends for keywords on Etsy and other marketplaces, 20 keywords at a time.',
        },
        {
          page_slug: 'bulk-keyword-tool',
        },
      ],
      requiresAuth: true,
    },
  },
];

export default routes;
